<template>
  <div class="space-y-2">
    <div v-if="block.data.url" class="mb-2"><img :src="block.data.url" class="w-full max-h-24 object-cover rounded border border-gray-200" /></div>
    <div><ConfigHelpLabel label="上传横幅图" help-key="block_banner_upload" label-class="text-[10px] text-gray-500" tag="div" /><input type="file" accept="image/jpeg,image/png,image/webp,image/gif" @change="handleUpload" class="w-full text-xs" :disabled="uploading" /></div>
    <div v-if="uploading" class="text-[10px] text-blue-500">上传中...</div>
    <div><ConfigHelpLabel label="或输入图片URL" help-key="block_banner_url" label-class="text-[10px] text-gray-500" tag="div" /><input v-model="block.data.url" @input="$emit('update')" class="w-full px-2 py-1 border border-gray-300 rounded text-xs" placeholder="https://..." /></div>
    <div><ConfigHelpLabel label="点击跳转链接（可选）" help-key="block_banner_link" label-class="text-[10px] text-gray-500" tag="div" /><input v-model="block.data.link" @input="$emit('update')" class="w-full px-2 py-1 border border-gray-300 rounded text-xs" placeholder="https://..." /></div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { qrCodeProService } from '@/services/qrCodeProService'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String] })
const emit = defineEmits(['update'])
const uploading = ref(false)
onMounted(() => { if (!props.block.data) props.block.data = {} })
async function handleUpload(e) {
  const file = e.target.files[0]; if (!file) return
  uploading.value = true
  const res = await qrCodeProService.uploadImage(props.pageId, file)
  uploading.value = false
  if (res.success) { props.block.data.url = res.url; emit('update') }
  else alert(res.message || '上传失败')
}
</script>
